import { Controller } from "@hotwired/stimulus"
import { VisitHelper } from "~/helpers/visit_helper"

export default class extends Controller {
  static get targets() {
    return ["loadingTemplate"]
  }

  setValue({ target: { value } }) {
    document.getElementById("campaigns_reporting_leaderboard").innerHTML = this.loadingTemplateTarget.innerHTML

    VisitHelper.update(["campaigns_reporting_leaderboard"], { "leaderboard[value]": value })
  }
}
